/** Strip trailing slashes from API root (paths are `/api/v1/...`). */
export function normalizeApiBaseUrl(url) {
	if (!url || typeof url !== "string") return "";
	return url.replace(/\/+$/, "");
}

/**
 * Ops console API root. Prefer explicit env in local dev; in staging/prod use
 * same-origin `/nodeapi` so stage-admin and stage hosts both work without CORS.
 */
const LOOPBACK_API = /^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?(\/|$)/i;

/** Mis-built bundles can bake local .env into staging; never call loopback from a real admin host. */
export function shouldUseSameOriginApi(apiRoot) {
	if (!apiRoot || !LOOPBACK_API.test(apiRoot)) return false;
	if (typeof window === "undefined") return false;
	const host = window.location.hostname;
	return host !== "localhost" && host !== "127.0.0.1";
}

export function resolveApiBaseUrl() {
	const fromEnv = normalizeApiBaseUrl(
		process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || "",
	);
	if (fromEnv) {
		if (shouldUseSameOriginApi(fromEnv)) {
			return "/nodeapi";
		}
		return fromEnv;
	}

	// Relative root: always same host as the admin SPA (stage-admin or stage).
	return "/nodeapi";
}
